export default __webpack_public_path__ + "static/inspiration-bathroom-d3893c53c7e4d2d4d94dd8f40c18e699.png";